import styled from '@emotion/styled';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { contentLibraryRoute } from 'App/common/routeLookup';
import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import SubmitButton from 'Shared/form/SubmitButton';
import { TAB_NAMES } from '../../ContentLibraryHome/contants';
import contentGroupPropType from '../../types/contentGroupPropType';
import { scrollContainerId } from '../constants';
import ContentLibraryEditContentVersion from './ContentLibraryEditContentVersion';
import CreateAssocationModal from './CreateAssociationModal';
import TemplateDisplayWithClipboard from './TemplateDisplayWithClipboard';

const ContentLibraryFormAreaStyle = styled.div`
    flex-grow: 1;
    padding: 20px;
    overflow: auto;

    .markdown-contents {
        height: 360px;
    }
`;

const ContentGroupHeaderStyle = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    font-size: 1.15em;

    .form-button-group {
        margin-top: 0;
    }
`;

const ContentLibraryEditFormArea = ({ contentGroup }) => {
    const navigate = useNavigate();
    const { values } = useFormikContext();
    const [showCreateAssociationModal, setShowCreateAssociationModal] = useState(false);
    const hasGpi10Mapping = contentGroup.type === TAB_NAMES.DRUG && Boolean(contentGroup.gpi10);

    return (
        <ContentLibraryFormAreaStyle id={scrollContainerId}>
            <ContentGroupHeaderStyle>
                <div>
                    <strong>{contentGroup.name} | </strong>
                    <TemplateDisplayWithClipboard templateText={contentGroup.label} />
                </div>
                <FormButtonGroup>
                    {contentGroup.type === TAB_NAMES.TEACHING && (
                        <Button variant="outline-secondary" onClick={() => setShowCreateAssociationModal(true)}>
                            Create Association
                        </Button>
                    )}
                    <Button
                        variant="outline-secondary"
                        onClick={() => navigate(`${contentLibraryRoute}?type=${contentGroup.type}`)}
                    >
                        Go Back
                    </Button>
                    <SubmitButton disabled={hasGpi10Mapping}>Save as Draft</SubmitButton>
                </FormButtonGroup>
            </ContentGroupHeaderStyle>

            {Object.values(values.contentVersions).map((contentVersion) => (
                <ContentLibraryEditContentVersion
                    disabled={hasGpi10Mapping}
                    key={contentVersion.uuid}
                    contentGroup={contentGroup}
                    contentVersion={contentVersion}
                    fieldName={`contentVersions.${contentVersion.uuid}.content`}
                />
            ))}

            {Object.values(values.children)
                .filter((child) => !child.deleted)
                .map((child) => (
                    <React.Fragment key={child.uuid}>
                        <ContentGroupHeaderStyle>
                            <div>
                                <strong>{child.name.replace(contentGroup.name, '')} | </strong>
                                <TemplateDisplayWithClipboard templateText={child.label} />
                            </div>
                        </ContentGroupHeaderStyle>
                        {Object.values(child.contentVersions).map((contentVersion) => (
                            <ContentLibraryEditContentVersion
                                disabled={hasGpi10Mapping}
                                key={contentVersion.uuid}
                                contentGroup={child}
                                contentVersion={contentVersion}
                                fieldName={`children.${child.uuid}.contentVersions.${contentVersion.uuid}.content`}
                            />
                        ))}
                    </React.Fragment>
                ))}

            {showCreateAssociationModal && (
                <CreateAssocationModal
                    contentGroup={contentGroup}
                    onClose={() => setShowCreateAssociationModal(false)}
                />
            )}
        </ContentLibraryFormAreaStyle>
    );
};

ContentLibraryEditFormArea.propTypes = {
    contentGroup: contentGroupPropType.isRequired,
};

export default ContentLibraryEditFormArea;
